<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <inertia-link v-if="$page.props.queryString && $page.props.queryString.dest === 'transfer'"
                        class="bg-gray-300 hover:bg-gray-500 text-black py-1 px-3 mx-3 rounded my-0"
                        :href="route('transfer.index')">
                        <i class="fas fa-arrow-left mx-1"></i> Transferência
                    </inertia-link>
                    <inertia-link v-if="$page.props.queryString && $page.props.queryString.dest === 'boleto'"
                        class="bg-gray-300 hover:bg-gray-500 text-black py-1 px-3 mx-3 rounded my-0"
                        :href="route('boleto.index')">
                        <i class="fas fa-arrow-left mx-1"></i> Boletos
                    </inertia-link>
                    <inertia-link
                        class="bg-blue-500 text-sm hover:bg-blue-700 text-white text-base font-bold py-3 px-6 rounded my-3"
                        :href="route('contact.create')">
                        Novo cadastro
                    </inertia-link>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Gerenciar cadastros
                </h2>
            </div>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                    <flash :timeout="5000"/>
                    <inertia-table
                        :data="contacts"
                        :params="params"
                        :filters="filters"
                        :columns="columns"
                        id="id"
                        routeName="contact.index"
                        @item-selected="show">
                        <template slot-scope="row" slot="created">
                            {{ row.item.created | smallDateTime }}
                        </template>
                    </inertia-table>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout';
import Welcome from './../../Jetstream/Welcome';
import Dropdown from '../../Jetstream/Dropdown';
import DropdownLink from '../../Jetstream/DropdownLink';
import JetAutoComplete from '../../Jetstream/AutoComplete';
import Flash from '../../Helpers/Flash';
import InertiaTable from '../../Helpers/Tables/InertiaTable';

export default {
    components: {
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable
    },
    props: ['contacts'],
    data() {
        return {
            columns: [
                {text: 'Documento', className: 'text-left', key: 'federal_document', sortable: true},
                {text: 'Nome', className: 'text-left', key: 'name', sortable: true},
                {text: 'Dt. Criação', className: 'text-left', key: 'created', sortable: true},
            ],
            filters: [],
            params: {
                sort: 'name:asc',
                page: 1,
                ...this.$page.props.queryString
            },
        }
    },
    methods: {
        show: function (item) {
            this.$inertia.get(this.route('contact.show', item.id));
        }
    }
}


</script>
